import React from "react";
import { SectionBadge, SectionBadgeVariants } from "../SectionBadge";
import { styles } from "./ContentNavigation.style";

export interface ContentNavigationItem {
  label: string;
  url: string;
  icon?: React.ReactNode;
}

export interface ContentNavigationProps {
  badge?: string;
  headline: string;
  headingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  items: ContentNavigationItem[];
}

export const ContentNavigation = ({ badge, headline, headingLevel = "h2", items }: ContentNavigationProps) => {
  const HeadingTag = headingLevel;
  const headingId = "content-navigation-heading";

  return (
    <section className={styles.section()} aria-labelledby={headingId}>
      <div className={styles.headlines()}>
        {badge && <SectionBadge text={badge} variant={SectionBadgeVariants.LightGrey} />}
        <HeadingTag id={headingId} className={styles.heading()}>
          {headline}
        </HeadingTag>
      </div>
      <ul className={styles.list()}>
        {items.map((item, index) => (
          <li key={index} className={styles.listItem()}>
            <span className={styles.iconWrapper()} aria-hidden="true">
              {item.icon}
            </span>
            <a href={item.url} className={styles.link()}>
              <span className={styles.label()}>{item.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
